export enum ItemInStockDialogForEnum {
  NoSkuUpdateItemInStock = 'NO_SKU_UPDATE_ITEM_IN_STOCK',
  AssetInventoryUpdateItemInStock = 'ASSET_INVENOTRY_UPDATE_ITEM_IN_STOCK',
}
